export const MILLISECONDS_PER_SECOND = 1000;

export const SECONDS_PER_MINUTE = 60;
export const MINUTES_PER_HOUR = 60;
export const HOURS_PER_DAY = 24;

export const MILLISECONDS_PER_MINUTE =
  MILLISECONDS_PER_SECOND * SECONDS_PER_MINUTE;
export const MILLISECONDS_PER_HOUR = MILLISECONDS_PER_MINUTE * MINUTES_PER_HOUR;
export const MILLISECONDS_PER_DAY = MILLISECONDS_PER_HOUR * HOURS_PER_DAY;
export const MILLISECONDS_PER_MONTH = MILLISECONDS_PER_DAY * 30;
export const MILLISECONDS_PER_YEAR = MILLISECONDS_PER_DAY * 365;

/**
 * Returns true if earlier time is within x seconds of the later time
 */
export function isWithinTimePeriod(
  earlier: Date,
  later: Date,
  differenceInSeconds: number
): boolean {
  const elapsedInMilliseconds = later.getTime() - earlier.getTime();
  const elapsedInSeconds = elapsedInMilliseconds / MILLISECONDS_PER_SECOND;

  return elapsedInSeconds < differenceInSeconds;
}

export function isMoreRecentThan(
  time: Date,
  differenceInSeconds: number
): boolean {
  return isWithinTimePeriod(time, new Date(Date.now()), differenceInSeconds);
}

export function isMoreRecentThan30Minutes(time: Date): boolean {
  return isMoreRecentThan(time, 30 * SECONDS_PER_MINUTE);
}
